/**
 * Checksum do estado da simulação.
 *
 * É a ferramenta que transforma "determinismo" de intenção em fato verificável:
 * o CI compara o checksum de 10.000 ticks entre Node e três navegadores (§23),
 * e o servidor compara o checksum de uma run revalidada com o que o cliente
 * alegou (§14.4). Sem isto, tanto o netcode quanto o ranking dependem de fé.
 *
 * FNV-1a de 32 bits sobre inteiros, em operações bitwise — exatas em qualquer
 * motor JS.
 */
const FNV_OFFSET = 0x811c9dc5;
export class Checksum {
    hash = FNV_OFFSET;
    /** Absorve um inteiro de 32 bits (com ou sem sinal). */
    push(value) {
        let v = value | 0;
        for (let byte = 0; byte < 4; byte++) {
            this.hash ^= v & 0xff;
            this.hash =
                (this.hash +
                    ((this.hash << 1) + (this.hash << 4) + (this.hash << 7) + (this.hash << 8) + (this.hash << 24))) >>>
                    0;
            v >>= 8;
        }
        return this;
    }
    /** Absorve um booleano. */
    pushBool(value) {
        return this.push(value ? 1 : 0);
    }
    /** Absorve uma string ASCII curta (identificador, estado enumerado). */
    pushText(text) {
        for (let i = 0; i < text.length; i++)
            this.push(text.charCodeAt(i));
        return this;
    }
    /** Valor corrente, como inteiro sem sinal. */
    get value() {
        return this.hash >>> 0;
    }
    /** Valor corrente em hexadecimal de 8 dígitos — o formato usado nos testes. */
    get hex() {
        return this.value.toString(16).padStart(8, '0');
    }
}
//# sourceMappingURL=checksum.js.map